import "./Footer.css";

export const Footer = () => {
  return (
    <div className="footer">
      <div>© 2025 Abdulmalek Al-Otaibi</div>
    </div>
  );
};
